import Vue from "vue";
import Vuex from "vuex";
import global from "@/app/store/modules/global";
import users from "@/app/store/modules/users";
import customers from "@/app/store/modules/customers";
import persongroups from "@/app/store/modules/persongroups";
import persons from "@/app/store/modules/persons";
import agreements from "@/app/store/modules/agreements";
import orders from "@/app/store/modules/orders";
import products from "@/app/store/modules/products";
import productpackages from "@/app/store/modules/productpackages";

Vue.use(Vuex);

export const modules = {
	global: global,
	users: users,
	customers: customers,
	persongroups: persongroups,
	persons: persons,
	agreements: agreements,
	orders: orders,
	products: products,
	productpackages: productpackages
};

export default new Vuex.Store({
	modules
});